import * as React from "react";
import styled from "styled-components";
const closeIcon = "https://i.ezbuy.sg/FjI8PeAeO6ln_xpIO1X-nim5Dn9t";
const CloseBtnWrap = styled.div `
	position: relative;
	width: 80vw;
	background-size: 100% 100%;
`;
const CloseBtn = styled.div `
	position: absolute;
	right: 0;
	top: 0.75rem;
	> img {
		width: 1.5625rem;
		height: 1.5625rem;
	}
`;
export default class ModalClose extends React.PureComponent {
    render() {
        const { children, onClose, style } = this.props;
        return (React.createElement(CloseBtnWrap, { style: style },
            React.createElement(CloseBtn, { onClick: onClose },
                React.createElement("img", { src: closeIcon })),
            React.createElement("div", null, children)));
    }
}
